import { useCallback } from "react";
import { providedModal } from "../others";
import { IMPREZA_BUTTON_PROPS, __ } from "../utils";
import { CancellationForm } from "../shortcode/account";
import { App } from "antd";
function useSubscriptionCancel(record) {
  const {
    modal
  } = App.useApp();
  return useCallback(async () => {
    providedModal("confirm", modalInstance => /*#__PURE__*/React.createElement(CancellationForm, {
      record: record,
      modal: modalInstance
    }), modal, {
      width: 500,
      title: __("Cancellation"),
      okButtonProps: {
        ...IMPREZA_BUTTON_PROPS,
        disabled: true
      },
      cancelText: __("Continue without cancellation"),
      okText: __("Cancel now")
    });
  }, [record]);
}
export { useSubscriptionCancel };